import { createSlice } from '@reduxjs/toolkit';

const purchaseOrdersSlice = createSlice({
  name: 'purchaseOrders',
  initialState: {
    purchaseOrders: [],
  },
  reducers: {
    setPurchaseOrders: (state, action) => {
      state.purchaseOrders = action.payload;
    },
  },
});

export const { setPurchaseOrders } = purchaseOrdersSlice.actions;

export default purchaseOrdersSlice.reducer;
